import Bugsnag from '@bugsnag/js';

// Identity helpers that ride alongside notifyError.js. Together they make
// every Bugsnag event self-describing: who tripped it (setBugsnagUser, called
// from UserSaga on signIn/me/initialLoad success) and which restaurant they
// were viewing (setBugsnagRestaurant, called from menuContext whenever the
// active restaurant changes). clearBugsnagUser is invoked on logout so
// post-logout errors are not attributed to the previous account.
//
// All helpers swallow their own errors. Instrumentation must never throw
// from a catch block or a redux saga.

const RESTAURANT_METADATA_SECTION = 'restaurant';

const pickUserId = (user) =>
  user?.id ?? user?.userId ?? user?.username ?? null;

export const setBugsnagUser = (user) => {
  try {
    if (!user) return;
    const id = pickUserId(user);
    const email = user.email || undefined;
    if (id == null && !email) return;
    // Name is intentionally omitted: account id + email is enough to triage,
    // and avoids pushing additional PII into Bugsnag.
    Bugsnag.setUser(id != null ? String(id) : undefined, email, undefined);
  } catch (_) {
    // noop
  }
};

export const clearBugsnagUser = () => {
  try {
    Bugsnag.setUser(undefined, undefined, undefined);
    Bugsnag.clearMetadata(RESTAURANT_METADATA_SECTION);
  } catch (_) {
    // noop
  }
};

export const setBugsnagRestaurant = (restaurant) => {
  try {
    if (!restaurant) {
      Bugsnag.clearMetadata(RESTAURANT_METADATA_SECTION);
      return;
    }
    Bugsnag.addMetadata(RESTAURANT_METADATA_SECTION, {
      id: restaurant.id ?? null,
      name: restaurant.name ?? null,
    });
  } catch (_) {
    // noop
  }
};
